import { useMemo } from 'react';

import { mapTypes } from '@ps-int/datasync-client';
import { GeneralThemesSettingsDatasyncSchema, GeneralThemesSettingsDatasyncService } from '@ps-int/general-themes';
import { useSelector } from 'react-redux';

import { getDatasyncClient } from '../../../helpers/datasync';
import { getConfig } from '../../config/selectors';
import { selectUserUid } from '../../user/selectors';
import { OnPremGeneralThemesSettingsService, readStoredOnPremGeneralThemes } from './onprem-general-themes-service';

const THEME_DB = 'ps';
const THEME_COLLECTION = 'settings';

export const useGeneralThemesSettingsDatasyncService = () => {
    const {
        isOnPremise,
        serverTime,
        psSettings,
        yaServices: { cloudAPIUrl },
    } = useSelector(getConfig);
    const userUid = useSelector(selectUserUid);

    const ds = useMemo(() => {
        if (isOnPremise) {
            const initialState = readStoredOnPremGeneralThemes() ?? psSettings?.generalThemes;

            return new OnPremGeneralThemesSettingsService(
                initialState
            ) as unknown as GeneralThemesSettingsDatasyncService;
        }

        const generalThemesWithDefaults = mapTypes(
            [{ id: 'generalThemes', value: JSON.stringify(psSettings?.generalThemes) }],
            GeneralThemesSettingsDatasyncSchema
        );

        const client = getDatasyncClient({ db: THEME_DB, collection: THEME_COLLECTION, userUid });

        return new GeneralThemesSettingsDatasyncService(client, generalThemesWithDefaults, {
            getNow: () => new Date(serverTime),
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userUid, cloudAPIUrl, serverTime]);

    return ds;
};
